import { Component, OnInit, Input, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { User } from 'solar-bo';
import { UserService } from '../user.service';

@Component({
  selector: 'app-user-changepwd',
  templateUrl: './user-changepwd.component.html',
  styleUrls: ['./user-changepwd.component.scss']
})
export class UserChangepwdComponent implements OnInit {

  @Input() model: User; // = { id: '-1', fullname: '' };
  submitted = false;
  listerrmessage:string="";
  alertmessage:any;
  alerttype="danger";
  myform: FormGroup;


  constructor(private adminService: UserService
    , private fb: FormBuilder
    , @Inject(MAT_DIALOG_DATA) public data: any
    ) {
      this.createForm();
      if (data != null) {
        if (data.model != null) {
          this.model=data.model;
        } 
      }
  }

  ngOnInit() {
  }

  createForm() {
    this.myform = this.fb.group({
      userpassword: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(24)]],
    });

  }
  changepch(){
    this.submitted = true;
    const formModel = this.myform.value;
      //update
      let userdto={"id":this.model.id,"Password":formModel.userpassword};
      /* this.adminService.updatepch(userdto)
        .subscribe(
          ()=>{
            this.alerttype="success",
        this.listerrmessage="Password changed"
        ,this.submitted=false}
        , err => {this.handleError(err)
        }); */
  }

  handleError<T>(err: any) {
    this.alerttype="danger";
    this.listerrmessage=("Error: " + err.message);
    this.submitted = false;
  }
}
